module.exports = __webpack_public_path__ + "static/media/_somaliland.ec26d047.png";